import { resolveUrl } from '../../utils/url';

/**
 * Full resolution image viewer overlay.
 * Displays when user clicks "Full res" button.
 *
 * Accepts either:
 * - `photo` object with `edited_url` property (Edit page)
 * - `url` string directly (View page)
 */
export default function FullResViewer({ photo, url, onClose }) {
  // Support both `photo.edited_url` (Edit page) and direct `url` prop (View page)
  const imageUrl = url || photo?.edited_url;
  if (!imageUrl) return null;

  return (
    <div
      className="fullres-viewer"
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.95)',
        zIndex: 10000,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      onClick={onClose}
    >
      <div
        style={{
          position: 'absolute',
          top: 16,
          right: 16,
          display: 'flex',
          gap: 12,
          zIndex: 10001,
        }}
      >
        <a
          href={resolveUrl(imageUrl)}
          download
          onClick={(e) => e.stopPropagation()}
          style={{
            padding: '8px 16px',
            background: 'rgba(255,255,255,0.1)',
            border: '1px solid rgba(255,255,255,0.2)',
            borderRadius: 6,
            color: '#fff',
            textDecoration: 'none',
            fontSize: 14,
          }}
        >
          Download
        </a>
        <button
          onClick={onClose}
          style={{
            padding: '8px 16px',
            background: 'rgba(255,255,255,0.1)',
            border: '1px solid rgba(255,255,255,0.2)',
            borderRadius: 6,
            color: '#fff',
            fontSize: 14,
            cursor: 'pointer',
          }}
        >
          Close (Esc)
        </button>
      </div>
      <div
        style={{
          position: 'absolute',
          bottom: 16,
          left: '50%',
          transform: 'translateX(-50%)',
          color: 'rgba(255,255,255,0.6)',
          fontSize: 13,
        }}
      >
        {photo?.filename || photo?.image_id || 'Full resolution'} - Click anywhere or press Esc to close
      </div>
      <img
        src={resolveUrl(imageUrl)}
        alt="Full resolution"
        onClick={(e) => e.stopPropagation()}
        style={{
          maxWidth: '95vw',
          maxHeight: '90vh',
          objectFit: 'contain',
          cursor: 'zoom-in',
        }}
        onDoubleClick={() => {
          // Open in new tab for even more zoom
          window.open(resolveUrl(imageUrl), '_blank');
        }}
      />
    </div>
  );
}
